import ApplicationSerializer from 'eflex/serializers/application';

export default class TaskConfigSerializer extends ApplicationSerializer {
  attrs = {
    strings: {
      embedded: 'always',
    },
    pushToScheduleConfigs: {
      embedded: 'always',
    },
    variableDefConfigs: {
      embedded: 'always',
    },
    hardwareInputDefConfigs: {
      embedded: 'always',
    },
    triggerConfigs: {
      embedded: 'always',
    },
    decisionDefConfigs: {
      embedded: 'always',
    },
    spindleConfigs: {
      embedded: 'always',
    },
  };
}
